import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  input,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { PcButtonIcon } from '@pc/common';
import { DialogSize } from './dialog-abstract.model';

@Component({
  selector: 'pc-dialog-abstract',
  standalone: true,
  imports: [CommonModule, NgClass, A11yModule],
  templateUrl: './dialog-abstract.component.html',
  styleUrl: './dialog-abstract.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogAbstractComponent implements OnDestroy {
  @Input() size: DialogSize = 'lg';
  @Output() closeDialog = new EventEmitter<void>();
  @ViewChild('dialogElement')
  dialogElement: ElementRef<HTMLElement> | null = null;
  public isMobile = input(false);
  public icon = PcButtonIcon.X_CLOSE;
  private renderer = inject(Renderer2);

  constructor() {
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
    setTimeout(() => {
      this.dialogElement?.nativeElement.focus();
    });
  }
  ngOnDestroy(): void {
    this.renderer.setStyle(document.body, 'overflow', 'unset');
  }
}
